import SkillTab from "./SkillTab";

export default SkillTab;
